<script setup lang="ts">
import {Models, useLocalization, useOrderViewContext} from '@hantera/portal-app';
import {computed} from 'vue';
import OrderAddress from './OrderAddress.vue';

const { state } = useOrderViewContext();
const t = useLocalization('components.order.addresses');

interface AddressContainer {
  key: string
  address: Models.Graph.Address | Models.Graph.InvoiceRecipient
  deliveries: Models.Graph.Delivery[]
  isInvoiceRecipient: boolean
}

function addressToKey(address: Models.Graph.Address) {
  return [
    address.addressLine1,
    address.addressLine2,
    address.city,
    address.countryCode,
    address.email,
    address.name,
    address.phone,
    address.state,
    address.postalCode].join('$').toLowerCase().replaceAll(' ', '');
}

const addresses = computed(() => {

  const addresses = state.deliveries.reduce((res, d) => {
    const key = addressToKey(d.deliveryAddress);
    if (!res[key]) {
      res[key] = {
        key,
        address: d.deliveryAddress,
        deliveries: [d],
        isInvoiceRecipient: false
      };
    } else {
      res[key].deliveries.push(d);
    }
    return res;
  }, <{
    [key: string]: AddressContainer
  }>{});

  if (state.invoiceRecipient) {
    const invoiceKey = addressToKey(state.invoiceRecipient);
    let invoiceRecipient = addresses[invoiceKey];
    if (invoiceRecipient) {
      invoiceRecipient.address = {
        ...invoiceRecipient.address,
        taxId: state.invoiceRecipient.taxId,
        taxIdType: state.invoiceRecipient.taxIdType,
        taxCountryCode: state.invoiceRecipient.taxCountryCode,
      }
      invoiceRecipient.isInvoiceRecipient = true;
    } else {
      addresses[invoiceKey] = {
        key: invoiceKey,
        address: state.invoiceRecipient,
        deliveries: [],
        isInvoiceRecipient: true,
      };
    }
  }

  return Object.values(addresses);
});


</script>

<template>
  <div>
    <div class="box-content-label">
      {{t('label')}}
    </div>
    <div
      class="order-addresses box-content box-pop"
    >
      <OrderAddress
        v-for="entry in addresses"
        :key="entry.key"
        :address="entry.address"
        :deliveries="entry.deliveries"
        :is-invoice-recipient="entry.isInvoiceRecipient"
      />
    </div>

  </div>
</template>

<style scoped>
.order-addresses {
  display: flex;
  flex-direction: column;
  padding: 0;

}
</style>